import { createSlice } from "@reduxjs/toolkit";
import {
  getInRepairInventoriesList,
  getInRepairInventorySubrows,
  getInventories,
  getInventoriesFilter,
  getInventoriesRR,
  getInventoryCountryNameTotalQtyGraph,
  getInventoryPartClassTotalQtyGraph,
  getInventoryPartTypeTotalQtyGraph,
  getInventorySubrows,
  getInventoryTeardownInventoryList,
  getInventoryTierGraphCountGraph,
  getINVUpdateTime,
  getROInventoriesList,
  getRepairOrderRAGDetail,
  getRepairOrderRAGListing,
  getRepairOrderRAGPriorityViewListing,
  getRepairOrderRAGPriorityViewSummary,
  getRepairOrderRveSnapshotChart,
  getRepairOrderRveSnapshotListing,
  getRepairOrderRveSnapshotSummary,
  getRepairOrderVendorScorecardGraph,
  getRepairOrderVendorScorecardListing,
  getRepairOrderVendorScorecardRagGraph,
  getRepairOrderAnalyticsDelayAttributionGraph,
  getRepairOrderAnalyticsPhaseVolumeGraph,
  getRepairOrderAnalyticsPriorityTierGraph,
  getRepairOrderAnalyticsRagDistributionGraph,
  getRepairOrderAnalyticsWorkstreamSplitGraph,
  getRepairOrderDataQualityListing,
  getRepairOrderDataQualitySummary,
  getRepairOrderRAGSubrows,
  getRepairOrderRAGSummary,
  getROInventorySubrows,
  getSlowMoveingInventoriesList,
  getSlowMoveingInventorySubrows,
  getStockSummaryInventoryDetails,
  getUnderStockInventoriesList,
  getUnderStockInventorySubrows,
} from "./inventoriesAction";
import { extractRepairOrderRagSubrowItems } from "../../../pages/inventory/in-repair/utils/inRepairListingUtils";

const repairOrderAnalyticsGraphLoadingKeys = [
  "repairOrderAnalyticsPriorityTierGraphLoading",
  "repairOrderAnalyticsWorkstreamSplitGraphLoading",
  "repairOrderAnalyticsRagDistributionGraphLoading",
  "repairOrderAnalyticsPhaseVolumeGraphLoading",
  "repairOrderAnalyticsDelayAttributionGraphLoading",
];

const updateRepairOrderAnalyticsInitialLoad = (state) => {
  if (repairOrderAnalyticsGraphLoadingKeys.every((key) => !state[key])) {
    state.isInitialLoadForRepairOrderAnalytics = false;
  }
};

export const initialState = {
  isInitialLoad: true,
  isInitialLoadForInRepair: true,
  isInitialLoadForTearDown: true,
  isInitialLoadForSlowMoveing: true,
  isInitialLoadForRepairOrderRag: true,
  isInitialLoadForRepairOrderRagPriorityView: true,
  isInitialLoadForRepairOrderRveSnapshot: true,
  isInitialLoadForRepairOrderVendorScorecard: true,
  isInitialLoadForRepairOrderAnalytics: true,
  isInitialLoadForRepairOrderDataQuality: true,
  isSlowMoveingLoading: false,
  loading: false,
  priorityViewLoading: false,
  rveSnapshotLoading: false,
  vendorScorecardLoading: false,
  dataQualityLoading: false,
  addLoading: false,
  underStockloading: false,
  isGraphdataLoading: false,
  inventories: {},
  inRepairInventories: {},
  roInventories: {},
  repairOrderRagListing: {},
  repairOrderRagListingRequestId: 0,
  repairOrderRagDetail: null,
  repairOrderRagDetailLoading: false,
  repairOrderRagSummary: {},
  repairOrderRagSummaryLoading: false,
  repairOrderRagPriorityViewListing: {},
  repairOrderRagPriorityViewListingRequestId: 0,
  repairOrderRagPriorityViewSummary: {},
  repairOrderRagPriorityViewSummaryLoading: false,
  repairOrderRveSnapshotListing: {},
  repairOrderRveSnapshotListingRequestId: 0,
  repairOrderRveSnapshotSummary: {},
  repairOrderRveSnapshotSummaryLoading: false,
  repairOrderRveSnapshotChart: {},
  repairOrderRveSnapshotChartLoading: false,
  repairOrderVendorScorecardListing: {},
  repairOrderVendorScorecardListingRequestId: 0,
  repairOrderVendorScorecardGraph: {},
  repairOrderVendorScorecardGraphLoading: false,
  repairOrderVendorScorecardRagGraph: {},
  repairOrderVendorScorecardRagGraphLoading: false,
  repairOrderAnalyticsPriorityTierGraph: {},
  repairOrderAnalyticsPriorityTierGraphLoading: false,
  repairOrderAnalyticsWorkstreamSplitGraph: {},
  repairOrderAnalyticsWorkstreamSplitGraphLoading: false,
  repairOrderAnalyticsRagDistributionGraph: {},
  repairOrderAnalyticsRagDistributionGraphLoading: false,
  repairOrderAnalyticsPhaseVolumeGraph: {},
  repairOrderAnalyticsPhaseVolumeGraphLoading: false,
  repairOrderAnalyticsDelayAttributionGraph: {},
  repairOrderAnalyticsDelayAttributionGraphLoading: false,
  repairOrderDataQualityListing: {},
  repairOrderDataQualityListingRequestId: 0,
  repairOrderDataQualitySummary: {},
  repairOrderDataQualitySummaryLoading: false,
  repairOrderRagSubrowLoading: {},
  repairOrderRagSubrows: {},
  inventoriesFilter: {},
  columnPreferences: {},
  underStockInventories: {},
  underStockDetails: {},
  rrInventories: {},
  teardown: {},
  isStockDetailsLoading: false,
  country: {},
  partCalss: {},
  tire: {},
  partType: {},
  slowMovingInventories: {},
  subrowLoading: {}, // changed from boolean to object
  inventorySubrows: {}, // changed from array to object
  updateTimeLoading: false,
};

const inventoriesSlice = createSlice({
  name: "inventories",
  initialState,
  reducers: {
    setInitialLoad: (state, action) => {
      state.isInitialLoad = action.payload;
    },
    setSlowMoveingInitialLoad: (state, action) => {
      state.isInitialLoadForSlowMoveing = action.payload;
    },
    setInitialLoadForRepairOrderRag: (state, action) => {
      state.isInitialLoadForRepairOrderRag = action.payload;
    },
    setInitialLoadForRepairOrderRagPriorityView: (state, action) => {
      state.isInitialLoadForRepairOrderRagPriorityView = action.payload;
    },
    setInitialLoadForRepairOrderRveSnapshot: (state, action) => {
      state.isInitialLoadForRepairOrderRveSnapshot = action.payload;
    },
    setInitialLoadForRepairOrderVendorScorecard: (state, action) => {
      state.isInitialLoadForRepairOrderVendorScorecard = action.payload;
    },
    setInitialLoadForRepairOrderAnalytics: (state, action) => {
      state.isInitialLoadForRepairOrderAnalytics = action.payload;
    },
    setInitialLoadForRepairOrderDataQuality: (state, action) => {
      state.isInitialLoadForRepairOrderDataQuality = action.payload;
    },
    clearRepairOrderRagDetail: (state) => {
      state.repairOrderRagDetail = null;
      state.repairOrderRagDetailLoading = false;
    },
    setTierInitialLoad: (state, action) => {
      state.isInitialLoadForTearDown = action.payload;
    },
    setloading: (state, action) => {
      state.loading = action.payload;
    },
    clearInventoriesData: (state) => {
      state.isInitialLoad = true;
      state.loading = false;
      state.addLoading = false;
      state.inventories = {};
      state.underStockInventories = {};
      state.inRepairInventories = {};
      state.roInventories = {};
      state.repairOrderRagListing = {};
      state.repairOrderRagSummary = {};
      state.repairOrderRagPriorityViewListing = {};
      state.repairOrderRagPriorityViewSummary = {};
      state.repairOrderRveSnapshotListing = {};
      state.repairOrderRveSnapshotSummary = {};
      state.repairOrderRveSnapshotChart = {};
      state.repairOrderVendorScorecardListing = {};
      state.repairOrderVendorScorecardGraph = {};
      state.repairOrderVendorScorecardRagGraph = {};
      state.repairOrderAnalyticsPriorityTierGraph = {};
      state.repairOrderAnalyticsWorkstreamSplitGraph = {};
      state.repairOrderAnalyticsRagDistributionGraph = {};
      state.repairOrderAnalyticsPhaseVolumeGraph = {};
      state.repairOrderAnalyticsDelayAttributionGraph = {};
      state.repairOrderDataQualityListing = {};
      state.repairOrderDataQualitySummary = {};
      state.repairOrderRagSubrowLoading = {};
      state.repairOrderRagSubrows = {};
      state.repairOrderRagDetail = null;
      state.inventoriesFilter = {};
      state.columnPreferences = {};
      state.underStockloading = {};
      state.subrowLoading = {};
      state.inventorySubrows = {};
      state.rrInventories = {};
    },
  },
  extraReducers: (builder) => {
    // Inventories list
    builder
      .addCase(getInventories.pending, (state) => {
        state.loading = true;
        state.subrowLoading = {};
        state.inventorySubrows = {};
      })
      .addCase(getInventories.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.inventories = action.payload;
      })
      .addCase(getInventories.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.inventories = {};
      })

      .addCase(getInventoryTeardownInventoryList.pending, (state) => {
        state.loading = true;
        state.subrowLoading = {};
        state.inventorySubrows = {};
      })
      .addCase(getInventoryTeardownInventoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoadForTearDown = false;
        state.isInitialLoad = false;
        state.teardown = action.payload;
      })
      .addCase(getInventoryTeardownInventoryList.rejected, (state) => {
        state.loading = false;
        state.isInitialLoadForTearDown = false;
        state.isInitialLoad = false;
        state.teardown = {};
      })

      // Inventories Filter
      .addCase(getInventoriesFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInventoriesFilter.fulfilled, (state, action) => {
        state.loading = false;

        state.inventoriesFilter = action.payload;
      })
      .addCase(getInventoriesFilter.rejected, (state) => {
        state.loading = false;
      })
      // In-Repair Inventories
      .addCase(getInRepairInventoriesList.pending, (state) => {
        state.loading = true;
        state.subrowLoading = {};
        state.inventorySubrows = {};
      })
      .addCase(getInRepairInventoriesList.fulfilled, (state, action) => {
        state.loading = false;
        state.inRepairInventories = action.payload;
        state.isInitialLoad = false;
        state.isInitialLoadForInRepair = false;
      })
      .addCase(getInRepairInventoriesList.rejected, (state, action) => {
        state.loading = false;
        state.inRepairInventories = action.payload;
        state.isInitialLoad = false;
        state.isInitialLoadForInRepair = false;
      })
      // RO Inventories
      .addCase(getROInventoriesList.pending, (state) => {
        state.loading = true;
        state.subrowLoading = {};
        state.inventorySubrows = {};
      })
      .addCase(getROInventoriesList.fulfilled, (state, action) => {
        state.loading = false;
        state.roInventories = action.payload;
        state.isInitialLoad = false;
      })
      .addCase(getROInventoriesList.rejected, (state, action) => {
        state.loading = false;
        state.roInventories = action.payload;
        state.isInitialLoad = false;
      })

      // Repair Order RAG Listing
      .addCase(getRepairOrderRAGListing.pending, (state, action) => {
        state.loading = true;
        state.repairOrderRagListingRequestId =
          action.meta.arg?._requestId ?? state.repairOrderRagListingRequestId;
        state.repairOrderRagSubrowLoading = {};
        state.repairOrderRagSubrows = {};
      })
      .addCase(getRepairOrderRAGListing.fulfilled, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !== state.repairOrderRagListingRequestId
        ) {
          return;
        }
        state.loading = false;
        state.repairOrderRagListing = action.payload;
        state.isInitialLoadForRepairOrderRag = false;
      })
      .addCase(getRepairOrderRAGListing.rejected, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !== state.repairOrderRagListingRequestId
        ) {
          return;
        }
        state.loading = false;
        state.repairOrderRagListing = {
          data: [],
          pagination: state.repairOrderRagListing?.pagination ?? {},
        };
        state.isInitialLoadForRepairOrderRag = false;
      })

      // Repair Order RAG Summary
      .addCase(getRepairOrderRAGSummary.pending, (state) => {
        state.repairOrderRagSummaryLoading = true;
      })
      .addCase(getRepairOrderRAGSummary.fulfilled, (state, action) => {
        state.repairOrderRagSummaryLoading = false;
        state.repairOrderRagSummary = action.payload;
      })
      .addCase(getRepairOrderRAGSummary.rejected, (state) => {
        state.repairOrderRagSummaryLoading = false;
        state.repairOrderRagSummary = {};
      })

      // Repair Order RAG Priority View Listing
      .addCase(getRepairOrderRAGPriorityViewListing.pending, (state, action) => {
        state.priorityViewLoading = true;
        state.repairOrderRagPriorityViewListingRequestId =
          action.meta.arg?._requestId ??
          state.repairOrderRagPriorityViewListingRequestId;
      })
      .addCase(getRepairOrderRAGPriorityViewListing.fulfilled, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderRagPriorityViewListingRequestId
        ) {
          return;
        }
        state.priorityViewLoading = false;
        state.repairOrderRagPriorityViewListing = action.payload;
        state.isInitialLoadForRepairOrderRagPriorityView = false;
      })
      .addCase(getRepairOrderRAGPriorityViewListing.rejected, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderRagPriorityViewListingRequestId
        ) {
          return;
        }
        state.priorityViewLoading = false;
        state.repairOrderRagPriorityViewListing = {
          data: [],
          pagination: state.repairOrderRagPriorityViewListing?.pagination ?? {},
        };
        state.isInitialLoadForRepairOrderRagPriorityView = false;
      })

      // Repair Order RAG Priority View Summary
      .addCase(getRepairOrderRAGPriorityViewSummary.pending, (state) => {
        state.repairOrderRagPriorityViewSummaryLoading = true;
      })
      .addCase(getRepairOrderRAGPriorityViewSummary.fulfilled, (state, action) => {
        state.repairOrderRagPriorityViewSummaryLoading = false;
        state.repairOrderRagPriorityViewSummary = action.payload;
      })
      .addCase(getRepairOrderRAGPriorityViewSummary.rejected, (state) => {
        state.repairOrderRagPriorityViewSummaryLoading = false;
        state.repairOrderRagPriorityViewSummary = {};
      })

      // Repair Order RVE Snapshot Listing
      .addCase(getRepairOrderRveSnapshotListing.pending, (state, action) => {
        state.rveSnapshotLoading = true;
        state.repairOrderRveSnapshotListingRequestId =
          action.meta.arg?._requestId ??
          state.repairOrderRveSnapshotListingRequestId;
      })
      .addCase(getRepairOrderRveSnapshotListing.fulfilled, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderRveSnapshotListingRequestId
        ) {
          return;
        }
        state.rveSnapshotLoading = false;
        state.repairOrderRveSnapshotListing = action.payload;
        state.isInitialLoadForRepairOrderRveSnapshot = false;
      })
      .addCase(getRepairOrderRveSnapshotListing.rejected, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderRveSnapshotListingRequestId
        ) {
          return;
        }
        state.rveSnapshotLoading = false;
        state.repairOrderRveSnapshotListing = {
          data: [],
          pagination: state.repairOrderRveSnapshotListing?.pagination ?? {},
        };
        state.isInitialLoadForRepairOrderRveSnapshot = false;
      })

      // Repair Order RVE Snapshot Summary
      .addCase(getRepairOrderRveSnapshotSummary.pending, (state) => {
        state.repairOrderRveSnapshotSummaryLoading = true;
      })
      .addCase(getRepairOrderRveSnapshotSummary.fulfilled, (state, action) => {
        state.repairOrderRveSnapshotSummaryLoading = false;
        state.repairOrderRveSnapshotSummary = action.payload;
      })
      .addCase(getRepairOrderRveSnapshotSummary.rejected, (state) => {
        state.repairOrderRveSnapshotSummaryLoading = false;
        state.repairOrderRveSnapshotSummary = {};
      })

      // Repair Order RVE Snapshot Chart
      .addCase(getRepairOrderRveSnapshotChart.pending, (state) => {
        state.repairOrderRveSnapshotChartLoading = true;
      })
      .addCase(getRepairOrderRveSnapshotChart.fulfilled, (state, action) => {
        state.repairOrderRveSnapshotChartLoading = false;
        state.repairOrderRveSnapshotChart = action.payload;
      })
      .addCase(getRepairOrderRveSnapshotChart.rejected, (state) => {
        state.repairOrderRveSnapshotChartLoading = false;
        state.repairOrderRveSnapshotChart = {};
      })

      // Repair Order Vendor Scorecard Listing
      .addCase(getRepairOrderVendorScorecardListing.pending, (state, action) => {
        state.vendorScorecardLoading = true;
        state.repairOrderVendorScorecardListingRequestId =
          action.meta.arg?._requestId ??
          state.repairOrderVendorScorecardListingRequestId;
      })
      .addCase(getRepairOrderVendorScorecardListing.fulfilled, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderVendorScorecardListingRequestId
        ) {
          return;
        }
        state.vendorScorecardLoading = false;
        state.repairOrderVendorScorecardListing = action.payload;
        state.isInitialLoadForRepairOrderVendorScorecard = false;
      })
      .addCase(getRepairOrderVendorScorecardListing.rejected, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderVendorScorecardListingRequestId
        ) {
          return;
        }
        state.vendorScorecardLoading = false;
        state.repairOrderVendorScorecardListing = {
          data: [],
          pagination: state.repairOrderVendorScorecardListing?.pagination ?? {},
        };
        state.isInitialLoadForRepairOrderVendorScorecard = false;
      })

      // Repair Order Vendor Scorecard Graph
      .addCase(getRepairOrderVendorScorecardGraph.pending, (state) => {
        state.repairOrderVendorScorecardGraphLoading = true;
      })
      .addCase(getRepairOrderVendorScorecardGraph.fulfilled, (state, action) => {
        state.repairOrderVendorScorecardGraphLoading = false;
        state.repairOrderVendorScorecardGraph = action.payload;
      })
      .addCase(getRepairOrderVendorScorecardGraph.rejected, (state) => {
        state.repairOrderVendorScorecardGraphLoading = false;
        state.repairOrderVendorScorecardGraph = {};
      })

      // Repair Order Vendor Scorecard RAG Graph
      .addCase(getRepairOrderVendorScorecardRagGraph.pending, (state) => {
        state.repairOrderVendorScorecardRagGraphLoading = true;
      })
      .addCase(getRepairOrderVendorScorecardRagGraph.fulfilled, (state, action) => {
        state.repairOrderVendorScorecardRagGraphLoading = false;
        state.repairOrderVendorScorecardRagGraph = action.payload;
      })
      .addCase(getRepairOrderVendorScorecardRagGraph.rejected, (state) => {
        state.repairOrderVendorScorecardRagGraphLoading = false;
        state.repairOrderVendorScorecardRagGraph = {};
      })

      // Repair Order Analytics — Priority Tier Graph
      .addCase(getRepairOrderAnalyticsPriorityTierGraph.pending, (state) => {
        state.repairOrderAnalyticsPriorityTierGraphLoading = true;
      })
      .addCase(getRepairOrderAnalyticsPriorityTierGraph.fulfilled, (state, action) => {
        state.repairOrderAnalyticsPriorityTierGraphLoading = false;
        state.repairOrderAnalyticsPriorityTierGraph = action.payload;
        updateRepairOrderAnalyticsInitialLoad(state);
      })
      .addCase(getRepairOrderAnalyticsPriorityTierGraph.rejected, (state) => {
        state.repairOrderAnalyticsPriorityTierGraphLoading = false;
        state.repairOrderAnalyticsPriorityTierGraph = {};
        updateRepairOrderAnalyticsInitialLoad(state);
      })

      // Repair Order Analytics — Workstream Split Graph
      .addCase(getRepairOrderAnalyticsWorkstreamSplitGraph.pending, (state) => {
        state.repairOrderAnalyticsWorkstreamSplitGraphLoading = true;
      })
      .addCase(getRepairOrderAnalyticsWorkstreamSplitGraph.fulfilled, (state, action) => {
        state.repairOrderAnalyticsWorkstreamSplitGraphLoading = false;
        state.repairOrderAnalyticsWorkstreamSplitGraph = action.payload;
        updateRepairOrderAnalyticsInitialLoad(state);
      })
      .addCase(getRepairOrderAnalyticsWorkstreamSplitGraph.rejected, (state) => {
        state.repairOrderAnalyticsWorkstreamSplitGraphLoading = false;
        state.repairOrderAnalyticsWorkstreamSplitGraph = {};
        updateRepairOrderAnalyticsInitialLoad(state);
      })

      // Repair Order Analytics — RAG Distribution Graph
      .addCase(getRepairOrderAnalyticsRagDistributionGraph.pending, (state) => {
        state.repairOrderAnalyticsRagDistributionGraphLoading = true;
      })
      .addCase(getRepairOrderAnalyticsRagDistributionGraph.fulfilled, (state, action) => {
        state.repairOrderAnalyticsRagDistributionGraphLoading = false;
        state.repairOrderAnalyticsRagDistributionGraph = action.payload;
        updateRepairOrderAnalyticsInitialLoad(state);
      })
      .addCase(getRepairOrderAnalyticsRagDistributionGraph.rejected, (state) => {
        state.repairOrderAnalyticsRagDistributionGraphLoading = false;
        state.repairOrderAnalyticsRagDistributionGraph = {};
        updateRepairOrderAnalyticsInitialLoad(state);
      })

      // Repair Order Analytics — Phase Volume Graph
      .addCase(getRepairOrderAnalyticsPhaseVolumeGraph.pending, (state) => {
        state.repairOrderAnalyticsPhaseVolumeGraphLoading = true;
      })
      .addCase(getRepairOrderAnalyticsPhaseVolumeGraph.fulfilled, (state, action) => {
        state.repairOrderAnalyticsPhaseVolumeGraphLoading = false;
        state.repairOrderAnalyticsPhaseVolumeGraph = action.payload;
        updateRepairOrderAnalyticsInitialLoad(state);
      })
      .addCase(getRepairOrderAnalyticsPhaseVolumeGraph.rejected, (state) => {
        state.repairOrderAnalyticsPhaseVolumeGraphLoading = false;
        state.repairOrderAnalyticsPhaseVolumeGraph = {};
        updateRepairOrderAnalyticsInitialLoad(state);
      })

      // Repair Order Analytics — Delay Attribution Graph
      .addCase(getRepairOrderAnalyticsDelayAttributionGraph.pending, (state) => {
        state.repairOrderAnalyticsDelayAttributionGraphLoading = true;
      })
      .addCase(getRepairOrderAnalyticsDelayAttributionGraph.fulfilled, (state, action) => {
        state.repairOrderAnalyticsDelayAttributionGraphLoading = false;
        state.repairOrderAnalyticsDelayAttributionGraph = action.payload;
        updateRepairOrderAnalyticsInitialLoad(state);
      })
      .addCase(getRepairOrderAnalyticsDelayAttributionGraph.rejected, (state) => {
        state.repairOrderAnalyticsDelayAttributionGraphLoading = false;
        state.repairOrderAnalyticsDelayAttributionGraph = {};
        updateRepairOrderAnalyticsInitialLoad(state);
      })

      // Repair Order Data Quality Summary
      .addCase(getRepairOrderDataQualitySummary.pending, (state) => {
        state.repairOrderDataQualitySummaryLoading = true;
      })
      .addCase(getRepairOrderDataQualitySummary.fulfilled, (state, action) => {
        state.repairOrderDataQualitySummaryLoading = false;
        state.repairOrderDataQualitySummary = action.payload;
      })
      .addCase(getRepairOrderDataQualitySummary.rejected, (state) => {
        state.repairOrderDataQualitySummaryLoading = false;
        state.repairOrderDataQualitySummary = {};
      })

      // Repair Order Data Quality Listing
      .addCase(getRepairOrderDataQualityListing.pending, (state, action) => {
        state.dataQualityLoading = true;
        state.repairOrderDataQualityListingRequestId =
          action.meta.arg?._requestId ??
          state.repairOrderDataQualityListingRequestId;
      })
      .addCase(getRepairOrderDataQualityListing.fulfilled, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderDataQualityListingRequestId
        ) {
          return;
        }
        state.dataQualityLoading = false;
        state.repairOrderDataQualityListing = action.payload;
        state.isInitialLoadForRepairOrderDataQuality = false;
      })
      .addCase(getRepairOrderDataQualityListing.rejected, (state, action) => {
        if (
          action.meta.arg?._requestId != null &&
          action.meta.arg._requestId !==
            state.repairOrderDataQualityListingRequestId
        ) {
          return;
        }
        state.dataQualityLoading = false;
        state.repairOrderDataQualityListing = {
          data: [],
          pagination: state.repairOrderDataQualityListing?.pagination ?? {},
        };
        state.isInitialLoadForRepairOrderDataQuality = false;
      })

      // Repair Order RAG Subrows
      .addCase(getRepairOrderRAGSubrows.pending, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.repairOrderRagSubrowLoading[rowId] = true;
      })
      .addCase(getRepairOrderRAGSubrows.fulfilled, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.repairOrderRagSubrowLoading[rowId] = false;
        state.repairOrderRagSubrows[rowId] = extractRepairOrderRagSubrowItems(
          action.payload
        );
      })
      .addCase(getRepairOrderRAGSubrows.rejected, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.repairOrderRagSubrowLoading[rowId] = false;
        state.repairOrderRagSubrows[rowId] = [];
      })

      // Repair Order RAG Detail
      .addCase(getRepairOrderRAGDetail.pending, (state) => {
        state.repairOrderRagDetailLoading = true;
        state.repairOrderRagDetail = null;
      })
      .addCase(getRepairOrderRAGDetail.fulfilled, (state, action) => {
        state.repairOrderRagDetailLoading = false;
        console.log("action.payload", action.payload);
        state.repairOrderRagDetail = action.payload?.data;
      })
      .addCase(getRepairOrderRAGDetail.rejected, (state) => {
        state.repairOrderRagDetailLoading = false;
        state.repairOrderRagDetail = null;
      })

      // Under Stock Inventories
      .addCase(getUnderStockInventoriesList.pending, (state) => {
        state.underStockloading = true;
        state.subrowLoading = {};
        state.inventorySubrows = {};
      })
      .addCase(getUnderStockInventoriesList.fulfilled, (state, action) => {
        state.underStockloading = false;
        state.underStockInventories = action.payload;
        state.isInitialLoad = false;
      })
      .addCase(getUnderStockInventoriesList.rejected, (state, action) => {
        state.underStockloading = false;
        state.underStockInventories = action.payload;
        state.isInitialLoad = false;
      })

      // Under stock details
      .addCase(getStockSummaryInventoryDetails.pending, (state) => {
        state.isStockDetailsLoading = true;
      })
      .addCase(getStockSummaryInventoryDetails.fulfilled, (state, action) => {
        state.isStockDetailsLoading = false;
        state.underStockDetails = action.payload;
        state.isInitialLoadForInRepair = false;
      })
      .addCase(getStockSummaryInventoryDetails.rejected, (state, action) => {
        state.isStockDetailsLoading = false;
        state.underStockDetails = action.payload;
        state.isInitialLoadForInRepair = false;
      })

      // Slow moveing Inventories

      .addCase(getSlowMoveingInventoriesList.pending, (state) => {
        state.isSlowMoveingLoading = true;
        state.subrowLoading = {};
        state.inventorySubrows = {};
      })
      .addCase(getSlowMoveingInventoriesList.fulfilled, (state, action) => {
        state.isSlowMoveingLoading = false;
        state.slowMovingInventories = action.payload;
        state.isInitialLoad = false;
        state.isInitialLoadForSlowMoveing = false;
      })
      .addCase(getSlowMoveingInventoriesList.rejected, (state, action) => {
        state.isSlowMoveingLoading = false;
        state.slowMovingInventories = action.payload;
        state.isInitialLoad = false;
        state.isInitialLoadForSlowMoveing = false;
      })

      //Graph

      .addCase(getInventoryCountryNameTotalQtyGraph.pending, (state) => {
        state.isGraphdataLoading = true;
      })
      .addCase(
        getInventoryCountryNameTotalQtyGraph.fulfilled,
        (state, action) => {
          state.isGraphdataLoading = false;
          state.country = action.payload.data;
          state.isInitialLoadForInRepair = false;
        }
      )
      .addCase(
        getInventoryCountryNameTotalQtyGraph.rejected,
        (state, action) => {
          state.isGraphdataLoading = false;
          state.country = action.payload.data;
          state.isInitialLoadForInRepair = false;
        }
      )

      .addCase(getInventoryPartClassTotalQtyGraph.pending, (state) => {
        state.isGraphdataLoading = true;
      })
      .addCase(
        getInventoryPartClassTotalQtyGraph.fulfilled,
        (state, action) => {
          state.isGraphdataLoading = false;
          state.partCalss = action.payload.data;
          state.isInitialLoadForInRepair = false;
        }
      )
      .addCase(getInventoryPartClassTotalQtyGraph.rejected, (state, action) => {
        state.isGraphdataLoading = false;
        state.partCalss = action.payload.data;
        state.isInitialLoadForInRepair = false;
      })

      .addCase(getInventoryTierGraphCountGraph.pending, (state) => {
        state.isGraphdataLoading = true;
      })
      .addCase(getInventoryTierGraphCountGraph.fulfilled, (state, action) => {
        state.isGraphdataLoading = false;
        state.tire = action.payload.data;
        state.isInitialLoadForInRepair = false;
      })
      .addCase(getInventoryTierGraphCountGraph.rejected, (state, action) => {
        state.isGraphdataLoading = false;
        state.tire = action.payload.data;
        state.isInitialLoadForInRepair = false;
      })

      .addCase(getInventoryPartTypeTotalQtyGraph.pending, (state) => {
        state.isGraphdataLoading = true;
      })
      .addCase(getInventoryPartTypeTotalQtyGraph.fulfilled, (state, action) => {
        state.isGraphdataLoading = false;
        state.partType = action.payload.data;
        state.isInitialLoadForInRepair = false;
      })
      .addCase(getInventoryPartTypeTotalQtyGraph.rejected, (state, action) => {
        state.isGraphdataLoading = false;
        state.partType = action.payload.data;
        state.isInitialLoadForInRepair = false;
      })

      // get inventories subrows data on row expand
      .addCase(getInventorySubrows.pending, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = true;
        state.inventorySubrows[rowId] = [];
      })
      .addCase(getInventorySubrows.fulfilled, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
        state.inventorySubrows[rowId] = action.payload?.data[0] || [];
      })
      .addCase(getInventorySubrows.rejected, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
      })

      .addCase(getUnderStockInventorySubrows.pending, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = true;
        state.inventorySubrows[rowId] = [];
      })
      .addCase(getUnderStockInventorySubrows.fulfilled, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
        state.inventorySubrows[rowId] = action.payload?.data[0] || [];
      })
      .addCase(getUnderStockInventorySubrows.rejected, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
      })

      .addCase(getInRepairInventorySubrows.pending, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = true;
        state.inventorySubrows[rowId] = [];
      })
      .addCase(getInRepairInventorySubrows.fulfilled, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
        state.inventorySubrows[rowId] = action.payload?.data[0] || [];
      })
      .addCase(getInRepairInventorySubrows.rejected, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
      })

      .addCase(getSlowMoveingInventorySubrows.pending, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = true;
        state.inventorySubrows[rowId] = [];
      })
      .addCase(getSlowMoveingInventorySubrows.fulfilled, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
        state.inventorySubrows[rowId] = action.payload?.data[0] || [];
      })
      .addCase(getSlowMoveingInventorySubrows.rejected, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
      })
      .addCase(getROInventorySubrows.pending, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = true;
        state.inventorySubrows[rowId] = [];
      })
      .addCase(getROInventorySubrows.fulfilled, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
        state.inventorySubrows[rowId] = action.payload?.data[0] || [];
      })
      .addCase(getROInventorySubrows.rejected, (state, action) => {
        const rowId = action.meta.arg.rowId;
        state.subrowLoading[rowId] = false;
      });
    // Recommended for Inventories list
    builder
      .addCase(getInventoriesRR.pending, (state) => {
        state.loading = true;
        state.subrowLoading = {};
        state.inventorySubrows = {};
      })
      .addCase(getInventoriesRR.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialLoad = false;
        state.rrInventories = action.payload;
      })
      .addCase(getInventoriesRR.rejected, (state) => {
        state.loading = false;
        state.isInitialLoad = false;
      })
    builder
      .addCase(getINVUpdateTime.pending, (state) => {
        state.updateTimeLoading = true;
      })
      .addCase(getINVUpdateTime.fulfilled, (state, action) => {
        state.updateTimeLoading = false;
      })
      .addCase(getINVUpdateTime.rejected, (state) => {
        state.updateTimeLoading = false;
      })
  },
});

export const {
  setInitialLoad,
  setSlowMoveingInitialLoad,
  setInitialLoadForRepairOrderRag,
  setInitialLoadForRepairOrderRagPriorityView,
  setInitialLoadForRepairOrderRveSnapshot,
  setInitialLoadForRepairOrderVendorScorecard,
  setInitialLoadForRepairOrderAnalytics,
  setInitialLoadForRepairOrderDataQuality,
  clearRepairOrderRagDetail,
  loading,
  clearInventoriesData,
  isInitialLoadForTearDown,
  isInitialLoadForInRepair,
  isInitialLoadForSlowMoveing,
  isSlowMoveingLoading,
  setloading,
  underStockloading,
  setTierInitialLoad,
} = inventoriesSlice.actions;
export default inventoriesSlice.reducer;
